function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5837 13.75C21.3971 13.75 21.8702 12.8306 21.3974 12.1688L18.5091 8.125L21.3974 4.08124C21.8702 3.41937 21.3971 2.5 20.5837 2.5H7.80121V2C7.80121 1.44772 7.35349 1 6.80121 1H4.58246C4.03017 1 3.58246 1.44772 3.58246 2V21.7812L3.58246 22.1875C3.58246 22.7398 4.03017 23.1875 4.58246 23.1875H6.80121C7.35349 23.1875 7.80121 22.7398 7.80121 22.1875V21.7812V13.75H20.5837ZM19.7943 3.90625L16.7809 8.125L19.7943 12.3438H7.80121V3.90625H19.7943ZM6.39496 21.7812H4.98871V3.10938C4.98871 2.72105 5.30351 2.40625 5.69183 2.40625C6.08016 2.40625 6.39496 2.72105 6.39496 3.10938V21.7812Z",
  fill: "#685DA8"
});

var SvgIcChallengeNutrition = function SvgIcChallengeNutrition(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcChallengeNutrition, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-challenge-nutrition.01315f0f.svg";
export { ForwardRef as ReactComponent };